export default {
  absoluteY: 89,
  absoluteX: 76,
  boxes: [
    {
      type: "primaryBox",
      x: 471,
      y: 72,
      strokeColor: "blue5",
      hoverColor: "blue0",
      text: "Product Thinking",
    },
    {
      type: "multiBox",
      x: 0,
      y: 0,
      width: 243,
      height: 333,
      fillColor: "blue0",
      text: "Pre-launch",
    },
    {
      type: "multiBox",
      x: 268,
      y: 233,
      width: 243,
      height: 198,
      fillColor: "blue0",
      text: "Launch",
    },
    {
      type: "multiBox",
      x: 616,
      y: 233,
      width: 243,
      height: 198,
      fillColor: "blue0",
      text: "Post-Launch",
    },
    {
      type: "multiBox",
      x: 885,
      y: 0,
      width: 243,
      height: 153,
      fillColor: "blue0",
      text: "Success Metrics",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 57,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Vision",
      hoverColor: "blue1",
    },

    {
      type: "tertiaryBox",
      x: 16,
      y: 102,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Strategy",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 147,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Value Proposition",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 192,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product-Market Fit",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 237,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Roadmap",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 282,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Pitch",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 284,
      y: 335,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Launch",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 284,
      y: 290,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "MVP",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 284,
      y: 380,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Press Release",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 632,
      y: 290,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Usage Analytics",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 632,
      y: 335,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Customer Retention",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 632,
      y: 380,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Product Pivot",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 57,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Business Metrics",
      hoverColor: "blue1",
    },
    {
      type: "tertiaryBox",
      x: 901,
      y: 102,
      width: 211,
      fillColor: "blue0",
      strokeColor: "blue3",
      text: "Design Metrics",
      hoverColor: "blue1",
    },
  ],
};
